export default __webpack_public_path__ + "static/media/society.e062d244.png";